<script lang="ts">
  import { _ } from "svelte-i18n";
  import Dropdown from "../Dropdown/Dropdown/Dropdown.svelte";
  import DropdownItem from "../Dropdown/DropdownItem/DropdownItem.svelte";
  import {
    type DOB,
    getDays,
    getMonths,
    getYears,
    mapMonth,
  } from "$lib/utils/dates/dates";
  import Typography from "$lib/components/Typography/Typography.svelte";

  export let dob: DOB = {
    day: "",
    month: "",
    year: "",
  };
  export let dark: boolean = false;
  export let disabled: { day: boolean; month: boolean; year: boolean } = {
    day: false,
    month: false,
    year: false,
  };

  let displayMonth: string;
  $: displayMonth = mapMonth(dob.month);
</script>

<style lang="scss">
  .dob-wrapper {
    display: flex;
    position: relative;
    padding-top: 24px;
    gap: 0.5rem;

    @include breakpoint(md) {
      flex-grow: 1;
      margin-top: 24px;
      margin-bottom: 0;
    }
  }

  .dob-label {
    position: absolute;
    top: 0;
  }
</style>

<div class="dob-wrapper">
  <div class="dob-label">
    <Typography
      component="p"
      variant="body1"
      theme={dark ? "on-surface" : "inverse-on-surface"}
      >{$_("dob.title")}</Typography
    >
  </div>
  <Dropdown
    label={$_("dob.day.title")}
    rounded={true}
    bind:selectedItem={dob.day}
    surfaceBackground={true}
    disabled={disabled.day}
  >
    {#each getDays() as day}
      <DropdownItem label={day} on:click={() => (dob.day = day)} />
    {/each}
  </Dropdown>
  <Dropdown
    label={$_("dob.month.title")}
    rounded={true}
    bind:selectedItem={displayMonth}
    surfaceBackground={true}
    disabled={disabled.month}
  >
    {#each getMonths() as month}
      <DropdownItem
        label={month.label}
        on:click={() => (dob.month = month.value)}
      />
    {/each}
  </Dropdown>
  <Dropdown
    label={$_("dob.year.title")}
    rounded={true}
    bind:selectedItem={dob.year}
    surfaceBackground={true}
    disabled={disabled.year}
  >
    {#each getYears() as year}
      <DropdownItem label={year} on:click={() => (dob.year = year)} />
    {/each}
  </Dropdown>
</div>
